import { render, staticRenderFns } from "./statistics-args.vue?vue&type=template&id=2a6e3026&scoped=true&"
import script from "./statistics-args.vue?vue&type=script&lang=js&"
export * from "./statistics-args.vue?vue&type=script&lang=js&"
import style0 from "./statistics-args.vue?vue&type=style&index=0&id=2a6e3026&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6e3026",
  null
  
)

export default component.exports